import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import {
  Pagination,
  Empty,
  Backtop,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  Button,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Cascader,
  Popover,
  Drawer,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Photoswipe from "vue-pswipe";
import request from "./utils/request";

// 引入 amfe-flexible 动态设置根字体大小
import "amfe-flexible";

// 根据屏幕宽度动态添加 desktop-only 类名
// 这样 postcss-max-width-plugin 生成的样式才能生效
function toggleDesktopOnlyClass() {
  const breakpoint = 1920; // 与 postcss-max-width-plugin 的 breakpoint 保持一致
  const currentWidth = window.innerWidth;

  if (currentWidth >= breakpoint) {
    document.documentElement.classList.add("desktop-only");
    document.body.classList.add("desktop-only");
  } else {
    document.documentElement.classList.remove("desktop-only");
    document.body.classList.remove("desktop-only");
  }
}

// 初始化
toggleDesktopOnlyClass();
// 监听窗口大小变化
window.addEventListener("resize", toggleDesktopOnlyClass);

Vue.use(Pagination);
Vue.use(Empty);
Vue.use(Backtop);
Vue.use(Icon);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Cascader);
Vue.use(Popover);
Vue.use(Drawer);
Vue.use(Photoswipe);
// Message 不是组件，需要挂载到原型上
Vue.prototype.$message = Message;
// 将axios挂载到Vue原型上，方便在组件中使用 this.$http
Vue.prototype.$http = request;
Vue.config.productionTip = false;

// 自定义指令：IntersectionObserver
Vue.directive("intersect", {
  inserted(el, binding) {
    const callback = binding.value;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        callback && callback(entry); // 触发你的回调
        observer.unobserve(el); // 如果只想触发一次
      }
    });

    observer.observe(el);
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
